import { createSlice } from '@reduxjs/toolkit'

export const brewingMethodsSlice = createSlice({
  name: 'brewingMethods',
  initialState: [],
  reducers: {
    updateBrewingMethods: (state, action) => {
      return action.payload;
    },
  },
})

export const { updateBrewingMethods } = brewingMethodsSlice.actions

export default brewingMethodsSlice.reducer
